<template><!-- 用户协议 -->
    <div class="user-agreement-detail">
        <div v-if="config.htmlStr" class="user-agreement-detail" v-html="config.htmlStr" />
    </div>
</template>

<script>
    const {
        htmlStr,
    } = require(`@/config/${process.env.VUE_APP_PROJECT}/agreement`)
    export default {
        name: 'Agreement',
        data() {
            return {
                config: {
                    htmlStr: htmlStr,
                },
            }
        },
    }
</script>

<style scoped>
    .user-agreement-detail{
        padding: 10px;
    }
</style>
